// extracted by mini-css-extract-plugin
export default {"TooltipPopover":"styles_TooltipPopover__AOL4c"};